import angular from 'angular';
import ProblemApiService from './ProblemApiService';


export default angular
  .module('resources.problem', [])
  .service('ProblemApiService', ProblemApiService)
  .name;
